import type {Variants} from 'motion/react';

export const SequenceCardAnim: Variants = {
    enter: {
        opacity: 1,
        y: '0px'
    },
    exit: {
        opacity: 0,
        y: '30px'
    },
    initial: {
        opacity: 0,
        y: '30px'
    }
};